import { EInfrastructureCategory } from 'shared/types/infrastructure';

const SET_INFRASTRUCTURE_CATEGORIES_ACTION = 'SET_INFRASTRUCTURE_CATEGORIES';

export interface IInfrastructureCategoriesAction {
  type: typeof SET_INFRASTRUCTURE_CATEGORIES_ACTION;
  payload: EInfrastructureCategory[];
}

const initialState: EInfrastructureCategory[] = [];

export const setInfrastructureCategories = (categories: EInfrastructureCategory[]): IInfrastructureCategoriesAction => {
  return {
    payload: categories,
    type: SET_INFRASTRUCTURE_CATEGORIES_ACTION,
  };
};

export const infrastructureCategoriesReducer = (
  state: EInfrastructureCategory[] = initialState,
  action: IInfrastructureCategoriesAction,
) => {
  switch (action.type) {
    case SET_INFRASTRUCTURE_CATEGORIES_ACTION:
      return action.payload;

    default:
      return state;
  }
};
